/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-class-component-methods */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Checkbox,
  Button,
} from 'react-bootstrap';

import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';

import DriverStore from '../../../stores/DriverStore';
import SessionStore from '../../../stores/SessionStore';
import ToastStore from '../../../stores/ToastStore';
import AssetsConfig from '../../../config/assets'; // only used for defaultPhotoFilename

import ChangePasswordModal from '../user/change-password-modal';

import { phoneRegex } from '../../../utils/validation-regex';
import { AvatarWithUpload } from '../user/AvatarWithUpload';

class DriverEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      first_name: '',
      last_name: '',
      phone: '',
      picture: AssetsConfig.defaultPhotoFilename,
      street: '',
      city: '',
      state: '',
      zipcode: '',
      receive_offers: false,
      errors: {},
      showChangePasswordModal: false,
      notification: {},
      successMessage: '',
      id: null,
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    ToastStore.addChangeListener(this.handleDriverUpdated);
    DriverStore.addChangeListener(this.handleStoreChange);
    if (id) {
      CustomersActionCreators.getDriver(id);
    }
  }

  componentWillUnmount() {
    ToastStore.removeChangeListener(this.handleDriverUpdated);
    DriverStore.removeChangeListener(this.handleStoreChange);
  }
  getHandleInputChange(field) {
    return (e) => {
      this.setState({
        [field]: e.target.value,
      });
    };
  }
  getHandleCheckboxChange(field) {
    return () => {
      this.setState({
        [field]: !this.state[field],
      });
    };
  }
  getValidationState(field) {
    if (Object.prototype.hasOwnProperty.call(this.state.errors, field)) {
      return 'error';
    }

    return null;
  }
  handleDismissAlert = () => {
    this.setState({
      notification: {},
      errors: {},
    });
  };

  populateForm = async () => {
    const driver = DriverStore.getDriver(this.props.match.params.id);
    if (!driver) {
      return;
    }

    const {
      _id,
      username,
      first_name,
      last_name,
      phone,
      picture,
      address = {},
      receive_offers,
    } = driver;

    const { street = '', city = '', state = '', zipcode = '' } = address;

    this.setState({
      _id,
      username,
      first_name: first_name || '',
      last_name: last_name || '',
      phone: phone || '',
      picture,
      street,
      city,
      state,
      zipcode,
      receive_offers,
    });
  };

  validate() {
    const errors = {};
    const { first_name, last_name, phone, username } = this.state;

    if (!first_name) {
      errors.first_name = 'FIRST_NAME_REQUIRED';
    }

    if (!last_name) {
      errors.last_name = 'LAST_NAME_REQUIRED';
    }

    if (!phone) {
      errors.phone = 'PHONE_REQUIRED';
    } else if (phone && !phoneRegex.test(phone)) {
      errors.phone = 'PHONE_NUMBER_NOT_VALID';
    }

    if (!username) {
      errors.username = 'USERNAME_NOT_VALID';
    }

    this.setState({
      errors,
      notification: {},
    });

    return errors;
  }

  handleUpdatePassword = (newPassword) => {
    CustomersActionCreators.updatePassword(
      this.props.match.params.id,
      newPassword,
    );
  };

  handleStoreChange = () => {
    this.populateForm();
  };

  handleDriverUpdated = () => {
    const notification = ToastStore.getLatestNotification();
    this.setState({ notification });
  };

  handleSubmit = () => {
    const errors = this.validate();
    const isValid = Object.keys(errors).length === 0;
    if (isValid) {
      const {
        _id,
        first_name,
        last_name,
        username,
        phone,
        street,
        city,
        state,
        zipcode,
        receive_offers,
      } = this.state;
      const driver = {
        _id,
        carrier: SessionStore.getUser()._id,
        name,
        first_name,
        last_name,
        username,
        phone,
        address: {
          street,
          city,
          state,
          zipcode,
        },
        receive_offers,
      };
      CustomersActionCreators.updateDriver(driver);
    }
  };

  renderErrors() {
    const { t } = this.props;
    if (Object.keys(this.state.errors).length > 0) {
      return (
        <Alert bsStyle="danger" onDismiss={this.handleDismissAlert}>
          <ul>
            {Object.keys(this.state.errors).map((errorKey) => (
              <li key={errorKey}>{t(this.state.errors[errorKey])}</li>
            ))}
          </ul>
        </Alert>
      );
    }
    return null;
  }

  renderPhoto() {
    const driver = DriverStore.getDriver(this.props.match.params.id);
    return (
      <div className="dropdown-wrapper">
        <AvatarWithUpload
          key={this.props.match.params.id}
          userId={this.props.match.params.id}
          altName={this.state.name}
          style={{
            borderWidth: 2,
            borderColor: '#5cb85c',
            borderStyle: 'dashed',
            borderRadius: 5,
            display: 'inline-block',
            padding: 0,
            textAlign: 'center',
          }}
          avatarClassName="img-responsive img-thumbnail"
        />
      </div>
    );
  }

  renderNotification() {
    const notification = this.state.notification || {};
    if (notification.title) {
      const level =
        notification.level === 'success' ? notification.level : 'danger';
      const { title, body } = notification;
      return (
        <Alert bsStyle={level} onDismiss={this.handleDismissAlert}>
          <p>{title}</p>
          <p>{body}</p>
        </Alert>
      );
    }
    return null;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="carrier-center">
        <Row>
          <Col md={12}>
            <h3>{t('EDIT_DRIVER')}</h3>
          </Col>
        </Row>
        <form>
          <Row>
            <Col md={6}>
              {this.renderNotification()}
              {this.renderErrors()}
              <FormGroup
                controlId="first_name"
                validationState={this.getValidationState('first_name')}
              >
                <ControlLabel>{t('FIRST_NAME')}</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.first_name}
                  placeholder={t('ENTER_FIRST_NAME')}
                  onChange={this.getHandleInputChange('first_name')}
                />
              </FormGroup>
              <FormGroup
                controlId="last_name"
                validationState={this.getValidationState('last_name')}
              >
                <ControlLabel>{t('LAST_NAME')}</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.last_name}
                  placeholder={t('ENTER_LAST_NAME')}
                  onChange={this.getHandleInputChange('last_name')}
                />
              </FormGroup>
              <FormGroup
                controlId="street"
                validationState={this.getValidationState('street')}
              >
                <ControlLabel>{titleize(t('STREET'))}</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.street}
                  placeholder={t('ENTER_STREET')}
                  onChange={this.getHandleInputChange('street')}
                />
              </FormGroup>
              <FormGroup
                controlId="city"
                validationState={this.getValidationState('city')}
              >
                <ControlLabel>{titleize(t('CITY'))}</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.city}
                  placeholder={t('ENTER_CITY')}
                  onChange={this.getHandleInputChange('city')}
                />
              </FormGroup>
              <Row>
                <Col md={6}>
                  <FormGroup
                    controlId="state"
                    validationState={this.getValidationState('state')}
                  >
                    <ControlLabel>{titleize(t('STATE'))}</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.state}
                      placeholder={t('ENTER_STATE')}
                      onChange={this.getHandleInputChange('state')}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup
                    controlId="zipcode"
                    validationState={this.getValidationState('zipcode')}
                  >
                    <ControlLabel>{titleize(t('ZIP_CODE'))}</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.zipcode}
                      placeholder={t('ENTER_ZIP_CODE')}
                      onChange={this.getHandleInputChange('zipcode')}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup
                controlId="username"
                validationState={this.getValidationState('username')}
              >
                <ControlLabel>{t('USERNAME')}</ControlLabel>
                <FormControl
                  type="username"
                  value={this.state.username}
                  placeholder={t('ENTER_USERNAME')}
                  onChange={this.getHandleInputChange('username')}
                />
              </FormGroup>
              <FormGroup
                controlId="phone"
                validationState={this.getValidationState('phone')}
              >
                <ControlLabel>{t('PHONE')}</ControlLabel>
                <FormControl
                  type="phone"
                  value={this.state.phone}
                  placeholder={t('ENTER_PHONE')}
                  onChange={this.getHandleInputChange('phone')}
                />
              </FormGroup>
              <Checkbox
                ref={(ref) => {
                  this.checkboxRef = ref;
                }}
                checked={this.state.receive_offers}
                value={this.state.receive_offers}
                onChange={this.getHandleCheckboxChange('receive_offers')}
              >
                {t('RECEIVE_OFFERS_QUESTION')}
              </Checkbox>
              <FormGroup>
                <Button bsStyle="primary" block onClick={this.handleSubmit}>
                  {t('SAVE')}
                </Button>
              </FormGroup>
            </Col>
            <Col md={3}>
              {this.renderPhoto()}
              <div style={{ marginTop: '1em' }}>
                <Button
                  onClick={() =>
                    this.setState({ showChangePasswordModal: true })
                  }
                >
                  {t('CHANGE_PASSWORD')}
                </Button>
              </div>
              <ChangePasswordModal
                show={this.state.showChangePasswordModal}
                onHide={() => this.setState({ showChangePasswordModal: false })}
                onSave={this.handleUpdatePassword}
              />
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

DriverEditForm.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withTranslation()(DriverEditForm);
